import { render, staticRenderFns } from "./NewsForm.vue?vue&type=template&id=14a7c846&scoped=true&"
import script from "./NewsForm.vue?vue&type=script&lang=js&"
export * from "./NewsForm.vue?vue&type=script&lang=js&"
import style0 from "./NewsForm.vue?vue&type=style&index=0&id=14a7c846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a7c846",
  null
  
)

export default component.exports